import React from 'react';
import { css, cx } from 'linaria';
import ButtonWithLoading from '../../../ui/Button';
import { theme } from '../../../Theme';

const sharedStyles = css`
  margin-bottom: 40px;
  label {
    display: flex;
    margin-top: 1em;
    align-items: center;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .invalid {
    label {
      color: #eb5757;
    }
  }
  .missingVariant {
    margin-right: 0.25em;
    height: 10px;
    width: 10px;
  }
`;

const relative = css`
  position: relative;
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`;

export function VariantSelector({
  product,
  variantHandler,
  showValidation,
  disableOutOfStock
}) {
  return (
    <div className={sharedStyles}>
      {product?.variants?.options?.map(option => {
        let showValidationMessage = false;
        if (
          showValidation &&
          variantHandler.getMissingOptions()?.includes(option)
        ) {
          showValidationMessage = true;
        }

        return (
          <ButtonSelect
            option={option}
            variantHandler={variantHandler}
            key={option.name}
            showValidationMessage={showValidationMessage}
            disableOutOfStock={disableOutOfStock}
          />
        );
      })}
    </div>
  );
}

function ButtonSelect({
  option,
  variantHandler,
  showValidationMessage,
  disableOutOfStock
}) {
  const { getSelectedValue, validateSelection, selectValue } = variantHandler;
  const selectedValue = getSelectedValue(option);
  // const t = useIntl();

  return (
    <div className="button-select-wrapper">
      <div className="options-title">
        <label>{option.name}</label>
      </div>
      <div
        className={cx(
          'button-select',
          buttonSelectStyles,
          showValidationMessage && 'invalid'
        )}
      >
        {option?.values?.map((value, index) => {
          const validation = validateSelection(value, option);

          const disabled =
            index !== 0 &&
            (validation === 'invalid' ||
              (disableOutOfStock && validation === 'outOfStock'));
          return (
            <ButtonWithLoading
              data-testid={option.name + value}
              key={option.name + value}
              onClick={() => selectValue(value, option)}
              disabled={disabled}
              secondary={value !== selectedValue}
              aria-pressed={value === selectedValue}
              className={relative}
            >
              {value}
              {disabled && (
                <svg
                  viewBox="0 0 1 1"
                  preserveAspectRatio="none"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1L1 0"
                    stroke="currentColor"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </svg>
              )}
            </ButtonWithLoading>
          );
        })}
      </div>
    </div>
  );
}

const buttonSelectStyles = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
  margin: 0.5rem 0;
  button {
    font-size: 12px !important;
    letter-spacing: -0.7px !important;
    width: 23.5%;
    background: ${theme.colors.accent} !important;
    border: 0 !important;
    padding: 0 10px 0 10px !important;
    height: 35px;
    border-radius: ${theme.button.desktop.borderRadius} !important;
    &.secondary {
      background: #e9e5df !important;
      :hover {
        background: ${theme.colors.accentlight} !important;
      }
    }
  }
  &.invalid button {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  @media screen and (max-width: 450px) {
    button {
      width: 23%;
      min-width: 80px;
    }
  }
`;
